export const ERROR_TYPES = {
	REGISTRATION: 'REGISTRATION',
	QUIZ: 'QUIZ'
};
